import {
  NomineeDetailsPayload,
  NomineeDetailsResponse,
} from "@/utils/types/NPS/Stepper/NomineeDetails";
import { put } from "@/services/axiosUitils";

const baseUrl = "/nps/registration";

class NomineeDetailsService {
  createNomineeDetails = async (
    ackId: string,
    payload: NomineeDetailsPayload,
    nextStep?: string
  ): Promise<NomineeDetailsResponse> => {
    const response = await put<NomineeDetailsResponse>(
      `${baseUrl}/${ackId}/${nextStep}/`,
      payload,
      {}
    );
    return response;
  };
}

const instance = new NomineeDetailsService();
export default instance;
